import omit from 'lodash/omit';

import { getOrgProducts } from '../api/orgs';

const ADD_ORG_PRODUCTS = 'ADD_ORG_PRODUCTS';
const ADD_PRODUCT_ORG = 'ADD_PRODUCT_ORG';
const REMOVE_PRODUCT_ORG = 'REMOVE_PRODUCT_ORG';
const REMOVE_ORG_PRODUCTS = 'REMOVE_ORG_PRODUCTS';

const INITIAL_STATE = {};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_ORG_PRODUCTS:
      return {
        ...state,
        [action.payload.orgId]: [...action.payload.products],
      };
    case ADD_PRODUCT_ORG:
      return {
        ...state,
        [action.payload.orgId]: [...state[action.payload.orgId], action.payload.product],
      };
    case REMOVE_PRODUCT_ORG:
      return {
        ...state,
        [action.payload.orgId]: [
          ...state[action.payload.orgId].filter(product => product.id !== action.payload.productId),
        ],
      };
    case REMOVE_ORG_PRODUCTS:
      return omit(state, [action.payload]);
    default:
      return state;
  }
}

export function fetchOrgProducts(orgId) {
  // eslint-disable-next-line no-unused-vars
  return async (dispatch) => {
    try {
      const { data } = await getOrgProducts(orgId);

      return dispatch({
        type: ADD_ORG_PRODUCTS,
        payload: { orgId, products: data },
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function addProductToOrg(orgId, product) {
  return {
    type: ADD_PRODUCT_ORG,
    payload: { orgId, product },
  };
}

export function removeProductFromOrg(orgId, productId) {
  return {
    type: REMOVE_PRODUCT_ORG,
    payload: { orgId, productId },
  };
}

export function removeOrgProducts(orgId) {
  return {
    type: REMOVE_ORG_PRODUCTS,
    payload: orgId,
  };
}
